module.exports = __webpack_public_path__ + "static/media/twitter.f5ca1186.svg";